import { Helmet } from 'react-helmet-async';

import { APP_CONFIG } from '@/constants/app-config';
import { useTwin } from '@/lib/hooks/api/twin.hook';
import { useAuth } from '@/lib/hooks/useAuth';
import useColors from '@/lib/hooks/useColors';
import { useSettingsStore } from '@/store';
import { RouteTypes } from '@/types/config-types';
import AuthGuard from './AuthGuard';

const AppRoute = ({ ...props }: RouteTypes) => {
  const { component: Component, name, path } = props;
  const { isAuthenticated } = useAuth();
  const { settings } = useSettingsStore();
  const { twinData } = useTwin();
  const PersonalityName = twinData?.personalityName;

  const { primaryColor } = useColors();

  const title = isAuthenticated
    ? path.startsWith('/chat/')
      ? `${PersonalityName ?? 'Chat'} | ${settings?.ui?.appName || APP_CONFIG.appName}`
      : name
        ? `${name} | ${settings?.ui?.appName || APP_CONFIG.appName}`
        : APP_CONFIG.appName
    : name
      ? `${name} | ${settings?.ui?.appName || APP_CONFIG.appName}`
      : APP_CONFIG.appName;

  const faviconUrl = settings?.ui?.theming?.logo?.favicon;

  return (
    <>
      <Helmet>
        <title>{title || 'Twin Protocol'}</title>
        <meta
          name="description"
          content="Sharing knowledge & wisdom to better the world"
        />
        <meta name="theme-color" content={primaryColor} />
        <meta
          name="apple-mobile-web-app-status-bar-style"
          content={primaryColor}
        />
        <link rel="icon" href={faviconUrl || "/favicon-16x16.png"}   sizes="16x16" type="image/png"/>
        <link rel="apple-touch-icon" href={faviconUrl|| "/favicon-32x32.png"}  sizes="32x32" />
        <link rel="mask-icon" href={faviconUrl ||"/apple-touch-icon.png"} color={primaryColor}   sizes="180x180" />       

        <link rel="manifest" href="/site.webmanifest" />
        {/* <link
          rel="mask-icon"
          href="/safari-pinned-tab.svg"
          color={primaryColor}
        /> */}
      </Helmet>
      <AuthGuard routeKey={props.routeKey}>
        <Component />
      </AuthGuard>
    </>
  );
};

export default AppRoute;
